export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      resolve(reader.result)
    }
    reader.onerror = function (error) {
      reject(error)
    }
  })
}

export const validateFileType = (file, formatArray, setFormat = null) => {
  var fileName = file.name
  var idxDot = fileName.lastIndexOf('.') + 1
  var extFile = fileName.substr(idxDot, fileName.length).toLowerCase()

  if (formatArray.includes(extFile)) {
    if (setFormat) setFormat(extFile)
    return true
  } else {
    alert('wrong file format')
    return false
  }
}
